import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import { Table, Pagination, Search, Icon, Button, Grid } from 'semantic-ui-react';
import { setActivePage, showLoading, hideLoading, getLoginRecords, getLoginRecordsById, sortLoginRecords } from '../actions';

class LoginRecords extends Component {
    state = {
        column: null,
        data: [],
        length: 0,
        direction: null,
        page: 0,
        rowsPerPage: 15,
        newLoginRecords: {
            name: '',
            email: '',
        },
        searchValue: ''
    }

    constructor(props) {
        super(props);
        props.showLoading('Retrieving Login Records . . . ');
        props.getLoginRecords({});
    }

    // Hover Navbar Column
    componentDidMount() {
        this.props.setActivePage('logins');
    }

    // Connection at maptostateprops
    // To Compare the data(before) and current data, make sure the data is updated.
    componentWillReceiveProps(nextProps) {
        if (this.props.login.list !== nextProps.login.list) {
            console.log(nextProps.login.list);
            console.log(this.props.login.list);
            this.setState({ data: _.chunk(nextProps.login.list, this.state.rowsPerPage), length: nextProps.login.list.length, column: nextProps.login.sortColumn, direction: nextProps.login.sortDirection, page: 0 });
            this.props.hideLoading();
        } else if ((this.props.login.sortColumn !== nextProps.login.sortColumn) || (this.props.login.sortDirection !== nextProps.login.sortDirection)) {
            this.setState({ data: _.chunk(nextProps.login.list, this.state.rowsPerPage), column: nextProps.login.sortColumn, direction: nextProps.login.sortDirection, page: 0 });
        }
    }

    handleSort = (clickedColumn) => () => {
        this.props.sortLoginRecords(clickedColumn);
    }

    handleLoginRecordsSelect = (id, e) => {
        // e.preventDefault();
        this.props.getLoginRecordsById(id);
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        if (e.keyCode !== 13) {
            return;
        }

        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.name) | re.test(result.email));

        let login_list = _.filter(this.props.login.list, isMatch);
        this.setState({ data: _.chunk(login_list, this.state.rowsPerPage), length: login_list.length });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving Login Records . . . ');
        this.props.getLoginRecords({});
        console.log("Refresh List");
    }

    render() {
        const { data, page, column, direction, rowsPerPage, length, searchValue } = this.state;

        return (
            <Fragment>
                <Grid>
                    <Grid.Column floated='left' width={14}>
                        <div class="ui icon input">
                            {/* Search Bar */}
                            <input type="text" placeholder="Search..." value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                            <i aria-hidden="true" class="search icon"></i>
                        </div>
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh'/></Button>
                    </Grid.Column>
                </Grid>

                <Table sortable celled structured selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell sorted={column === 'id' ? direction : null} onClick={this.handleSort('id')}>
                                Login History
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                                Name
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'email' ? direction : null} onClick={this.handleSort('email')}>
                                Email
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data[page] &&
                         (data.length > 0) ?
                            data[page].map((loginrecords, index) => {
                                return (
                                    // To have a key to loop the data out.
                                    <Table.Row key={index}>
                                        <Table.Cell>{loginrecords._id ? moment(loginrecords._id).format('DD/MM/YYYY HH:mm') : 'Never'}</Table.Cell>
                                        <Table.Cell>{loginrecords.name}</Table.Cell>
                                        <Table.Cell><a href={'mailto:' + loginrecords.email} onClick={(e) => e.stopPropagation()}>{loginrecords.email}</a></Table.Cell>
                                    </Table.Row>)
                            }) :
                            <Table.Row>
                            <Table.Cell colSpan="7" textAlign="center">
                                No Record Found
                             </Table.Cell>
                        </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ login }) => {
    return { login }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        showLoading: showLoading,
        hideLoading: hideLoading,
        getLoginRecords: getLoginRecords,
        getLoginRecordsById: getLoginRecordsById,
        sortLoginRecords: sortLoginRecords
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(LoginRecords);